import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  info: {
    height: 20,
    width: 20,
    paddingLeft: 2
  },
  desktopLabel: {
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    color: theme.palette.secondary.main,
    textTransform: 'none',
    fontFamily: 'Libre Franklin',
    cursor: 'pointer'
  },
  tooltip: {
    backgroundColor: theme.colorPalette.green_10,
    fontSize: 15
  }
});

export default makeStyles(styles);
